var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ visible: _vm.isVisible },on:{"click":_vm.toTop}},[_c('img',{attrs:{"src":require("../assets/arrow-top-blue.svg")}}),_c('div',[_vm._v("Page Top")])])}
var staticRenderFns = []

export { render, staticRenderFns }